// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Base Layout === */
.signin-3d-root {
  min-height: 100vh;
  overflow: hidden;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  background:
    radial-gradient(circle at 15% 15%, rgba(124, 58, 237, 0.22), transparent 32%),
    radial-gradient(circle at 85% 80%, rgba(59, 130, 246, 0.22), transparent 32%),
    linear-gradient(135deg, #f8fbff 0%, #eef2ff 45%, #f7f2ff 100%);
}

.auth-shell {
  width: min(1180px, 94vw);
  min-height: 680px;

  display: grid;
  grid-template-columns: 1fr 430px;
  align-items: center;
  gap: 70px;

  position: relative;
  z-index: 2;
}

.canvas-wrap {
  position: relative;
  width: 100%;
  height: 660px;
  overflow: visible;
}

.canvas-wrap canvas {
  width: 100% !important;
  height: 100% !important;
}

.robot-glow {
  position: absolute;
  width: 460px;
  height: 460px;
  left: 50%;
  top: 52%;
  transform: translate(-50%, -50%);

  background: radial-gradient(
    circle,
    rgba(139, 92, 246, 0.26),
    rgba(59, 130, 246, 0.14),
    transparent 70%
  );

  filter: blur(55px);
  border-radius: 999px;
  animation: robotGlow 4s ease-in-out infinite;
}

@keyframes robotGlow {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.12);
  }
}

.signin-card {
  width: 430px;
  padding: 42px;
  border-radius: 30px;

  background: rgba(255, 255, 255, 0.74);
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);

  border: 1px solid rgba(255, 255, 255, 0.55);

  box-shadow:
    0 30px 80px rgba(79, 70, 229, 0.16),
    0 8px 25px rgba(0, 0, 0, 0.06);

  transition: 0.3s ease;
}

.signin-card:hover {
  transform: translateY(-5px);
  box-shadow:
    0 36px 90px rgba(79, 70, 229, 0.22),
    0 10px 30px rgba(0, 0, 0, 0.08);
}

.title {
  text-align: center;
  font-size: 34px;
  font-weight: 800;
  color: #111827;
  margin-bottom: 10px;
}

.subtitle {
  text-align: center;
  color: #6b7280;
  font-size: 16px;
  margin-bottom: 34px;
}

.form label {
  display: block;
  font-weight: 700;
  color: #222;
  margin-bottom: 10px;
}

.req {
  color: #ef4444;
}

.form input {
  width: 100%;
  height: 54px;

  padding: 0 16px;

  border-radius: 13px;
  border: 1px solid #d4d4d8;
  outline: none;

  font-size: 16px;
  color: #1f2937;
  background: rgba(255, 255, 255, 0.85);

  margin-bottom: 20px;
  transition: 0.25s ease;
}

.form input:focus {
  border-color: #7c3aed;
  box-shadow: 0 0 0 4px rgba(124, 58, 237, 0.12);
  background: #fff;
}

.password-wrap {
  position: relative;
}

.password-wrap input {
  padding-right: 58px;
}

.eye {
  position: absolute;
  right: 14px;
  top: 14px;

  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 18px;
}

.submit {
  width: 100%;
  height: 56px;

  border: none;
  border-radius: 14px;

  background: linear-gradient(135deg, #7c3aed, #8b5cf6, #6366f1);
  color: #fff;

  font-size: 17px;
  font-weight: 800;

  cursor: pointer;
  transition: 0.25s ease;
}

.submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 28px rgba(124, 58, 237, 0.32);
}

.submit:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.foot {
  text-align: center;
  margin-top: 24px;
  color: #555;
}

.foot a {
  color: #5b21b6;
  text-decoration: none;
  font-weight: 700;
}

.error-msg {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.18);
  padding: 10px 12px;
  border-radius: 12px;
  margin-bottom: 14px;
  font-size: 14px;
}

.speech-bubble {
  position: absolute;
  top: 14%;
  left: 15%;
  z-index: 10;

  width: fit-content;
  max-width: 340px;

  padding: 14px 20px;
  border-radius: 18px;

  background: rgba(255, 255, 255, 0.9);
  color: #1f2937;

  font-size: 15px;
  font-weight: 600;

  box-shadow: 0 14px 35px rgba(0, 0, 0, 0.1);
  pointer-events: none;
}

.auth-bg-orb {
  position: absolute;
  border-radius: 999px;
  filter: blur(55px);
  opacity: 0.55;
  animation: floatOrb 7s ease-in-out infinite;
}

.orb-1 {
  width: 320px;
  height: 320px;
  left: -70px;
  top: -70px;
  background: #c4b5fd;
}

.orb-2 {
  width: 260px;
  height: 260px;
  right: 10%;
  bottom: 4%;
  background: #bfdbfe;
  animation-delay: 1.4s;
}

.orb-3 {
  width: 220px;
  height: 220px;
  left: 45%;
  top: 15%;
  background: #ddd6fe;
  animation-delay: 2s;
}

@keyframes floatOrb {
  0%, 100% {
    transform: translateY(0) translateX(0);
  }
  50% {
    transform: translateY(-28px) translateX(18px);
  }
}

@media (max-width: 992px) {
  .auth-shell {
    grid-template-columns: 1fr;
    gap: 20px;
    min-height: auto;
    padding: 30px 0;
  }

  .canvas-wrap {
    height: 360px;
  }

  .signin-card {
    width: min(430px, 92vw);
    margin: 0 auto;
  }
}

/* Make sure the 3D canvas fits */
.canvas-wrap canvas {
    width: 100% !important;
    height: 100% !important;
}
/* Robot Glow */
.robot-glow {
  position: absolute;
  width: 420px;
  height: 420px;

  left: 12%;
  top: 50%;

  transform: translateY(-50%);

  background: radial-gradient(
    circle,
    rgba(124, 58, 237, 0.28),
    rgba(59, 130, 246, 0.18),
    transparent 70%
  );

  filter: blur(60px);
  border-radius: 50%;
  z-index: 0;

  animation: pulseGlow 5s ease-in-out infinite;
}

@keyframes pulseGlow {
  0% {
    transform: translateY(-50%) scale(1);
  }
  50% {
    transform: translateY(-50%) scale(1.08);
  }
  100% {
    transform: translateY(-50%) scale(1);
  }
}
/* === Chat bubble above robot === */
.speech-bubble {
  position: absolute;
  top: 20%;
  left: 18%;
  z-index: 10;

  width: fit-content;
  max-width: 360px;
  min-width: 0;

  padding: 14px 22px;
  border-radius: 18px;
  background: #fff;
  color: #222;

  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;

  white-space: normal;
  overflow-wrap: break-word;
  word-break: normal;

  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.12);
  pointer-events: none;
}

.typing-text {
  display: inline;
}
.speech-bubble::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 40%;
    border-width: 8px;
    border-style: solid;
    border-color: white transparent transparent transparent;
}

/* === Login Card === */
.signin-card {
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    padding: 40px;
    width: 380px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    z-index: 5;
}

.title {
    font-size: 1.8rem;
    font-weight: 700;
    color: #111;
    text-align: center;
}

.subtitle {
    text-align: center;
    color: #666;
    margin-top: -10px;
    margin-bottom: 10px;
}

.google-cta {
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s;
}

.google-cta:hover {
    background: #f9f9f9;
}

.google-icon {
    width: 20px;
    height: 20px;
}

.sep {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 0.85rem;
}

.sep span::before,
.sep span::after {
    content: '';
    display: inline-block;
    width: 35px;
    height: 1px;
    background: #ddd;
    vertical-align: middle;
    margin: 0 10px;
}

.form {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.form label {
    font-weight: 600;
    color: #333;
}

.req {
    color: #e63946;
}

.form input {
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 10px;
    font-size: 0.95rem;
    transition: 0.2s border-color;
}

.form input:focus {
    outline: none;
    border-color: #7c5dfa;
    box-shadow: 0 0 0 2px rgba(124, 93, 250, 0.15);
}

.password-wrap {
    display: flex;
    align-items: center;
    position: relative;
}

.password-wrap .eye {
    position: absolute;
    right: 10px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.2rem;
}

.row-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.85rem;
}

.cb input {
    margin-right: 6px;
}

.forgot {
    text-decoration: none;
    color: #7c5dfa;
}

.submit {
    background: #7c5dfa;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 12px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: 0.25s all;
}

.submit:hover {
    background: #6a48f7;
}

.foot {
    text-align: center;
    font-size: 0.85rem;
    color: #555;
}

/* === RESPONSIVE BREAKPOINTS === */

/* Tablet (<= 1024px) */
@media (max-width: 1024px) {
    .signin-3d-root {
        flex-direction: column;
        gap: 30px;
    }

    .canvas-wrap {
        width: 100%;
        height: 50vh;
        margin-bottom: -30px;
    }

    .signin-card {
        width: 90%;
        max-width: 400px;
    }

    .speech-bubble {
        top: 10%;
        font-size: 0.85rem;
    }
}

/* Mobile (<= 600px) */
@media (max-width: 600px) {
    .signin-3d-root {
        flex-direction: column;
        justify-content: flex-start;
        padding-top: 40px;
        height: auto;
        min-height: 100vh;
    }

    .canvas-wrap {
        width: 100%;
        height: 280px;
    }

    .signin-card {
        width: 95%;
        padding: 25px;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
    }

    .title {
        font-size: 1.5rem;
    }

    .subtitle {
        font-size: 0.9rem;
    }

    .speech-bubble {
        font-size: 0.8rem;
        top: 5%;
        left: 50%;
    }

    .submit {
        padding: 10px;
        font-size: 0.95rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/SignIn.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;;EAElB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB;;;kEAGgE;AAClE;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;;EAEjB,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;;EAET,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,QAAQ;EACR,gCAAgC;;EAEhC;;;;;GAKC;;EAED,kBAAkB;EAClB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;;EAEnB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;;EAEnC,2CAA2C;;EAE3C;;kCAEgC;;EAEhC,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B;;mCAEiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,eAAe;;EAEf,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;;EAEb,eAAe;EACf,cAAc;EACd,qCAAqC;;EAErC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;;EAET,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,YAAY;EACZ,mBAAmB;;EAEnB,8DAA8D;EAC9D,WAAW;;EAEX,eAAe;EACf,gBAAgB;;EAEhB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;;EAEX,kBAAkB;EAClB,gBAAgB;;EAEhB,kBAAkB;EAClB,mBAAmB;;EAEnB,oCAAoC;EACpC,cAAc;;EAEd,eAAe;EACf,gBAAgB;;EAEhB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,cAAc;EAChB;AACF;;AAEA,iCAAiC;AACjC;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;AACA,eAAe;AACf;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;;EAEb,SAAS;EACT,QAAQ;;EAER,2BAA2B;;EAE3B;;;;;GAKC;;EAED,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;;EAEV,4CAA4C;AAC9C;;AAEA;EACE;IACE,oCAAoC;EACtC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,oCAAoC;EACtC;AACF;AACA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;;EAEX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;;EAEZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;;EAEX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;EAEhB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;;EAElB,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,uDAAuD;AAC3D;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA,mCAAmC;;AAEnC,uBAAuB;AACvB;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,QAAQ;QACR,kBAAkB;IACtB;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,iBAAiB;QACjB,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,0CAA0C;IAC9C;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,OAAO;QACP,SAAS;IACb;;IAEA;QACI,aAAa;QACb,kBAAkB;IACtB;AACJ","sourcesContent":["/* === Base Layout === */\n.signin-3d-root {\n  min-height: 100vh;\n  overflow: hidden;\n  position: relative;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background:\n    radial-gradient(circle at 15% 15%, rgba(124, 58, 237, 0.22), transparent 32%),\n    radial-gradient(circle at 85% 80%, rgba(59, 130, 246, 0.22), transparent 32%),\n    linear-gradient(135deg, #f8fbff 0%, #eef2ff 45%, #f7f2ff 100%);\n}\n\n.auth-shell {\n  width: min(1180px, 94vw);\n  min-height: 680px;\n\n  display: grid;\n  grid-template-columns: 1fr 430px;\n  align-items: center;\n  gap: 70px;\n\n  position: relative;\n  z-index: 2;\n}\n\n.canvas-wrap {\n  position: relative;\n  width: 100%;\n  height: 660px;\n  overflow: visible;\n}\n\n.canvas-wrap canvas {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.robot-glow {\n  position: absolute;\n  width: 460px;\n  height: 460px;\n  left: 50%;\n  top: 52%;\n  transform: translate(-50%, -50%);\n\n  background: radial-gradient(\n    circle,\n    rgba(139, 92, 246, 0.26),\n    rgba(59, 130, 246, 0.14),\n    transparent 70%\n  );\n\n  filter: blur(55px);\n  border-radius: 999px;\n  animation: robotGlow 4s ease-in-out infinite;\n}\n\n@keyframes robotGlow {\n  0%, 100% {\n    transform: translate(-50%, -50%) scale(1);\n  }\n  50% {\n    transform: translate(-50%, -50%) scale(1.12);\n  }\n}\n\n.signin-card {\n  width: 430px;\n  padding: 42px;\n  border-radius: 30px;\n\n  background: rgba(255, 255, 255, 0.74);\n  backdrop-filter: blur(22px);\n  -webkit-backdrop-filter: blur(22px);\n\n  border: 1px solid rgba(255, 255, 255, 0.55);\n\n  box-shadow:\n    0 30px 80px rgba(79, 70, 229, 0.16),\n    0 8px 25px rgba(0, 0, 0, 0.06);\n\n  transition: 0.3s ease;\n}\n\n.signin-card:hover {\n  transform: translateY(-5px);\n  box-shadow:\n    0 36px 90px rgba(79, 70, 229, 0.22),\n    0 10px 30px rgba(0, 0, 0, 0.08);\n}\n\n.title {\n  text-align: center;\n  font-size: 34px;\n  font-weight: 800;\n  color: #111827;\n  margin-bottom: 10px;\n}\n\n.subtitle {\n  text-align: center;\n  color: #6b7280;\n  font-size: 16px;\n  margin-bottom: 34px;\n}\n\n.form label {\n  display: block;\n  font-weight: 700;\n  color: #222;\n  margin-bottom: 10px;\n}\n\n.req {\n  color: #ef4444;\n}\n\n.form input {\n  width: 100%;\n  height: 54px;\n\n  padding: 0 16px;\n\n  border-radius: 13px;\n  border: 1px solid #d4d4d8;\n  outline: none;\n\n  font-size: 16px;\n  color: #1f2937;\n  background: rgba(255, 255, 255, 0.85);\n\n  margin-bottom: 20px;\n  transition: 0.25s ease;\n}\n\n.form input:focus {\n  border-color: #7c3aed;\n  box-shadow: 0 0 0 4px rgba(124, 58, 237, 0.12);\n  background: #fff;\n}\n\n.password-wrap {\n  position: relative;\n}\n\n.password-wrap input {\n  padding-right: 58px;\n}\n\n.eye {\n  position: absolute;\n  right: 14px;\n  top: 14px;\n\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.submit {\n  width: 100%;\n  height: 56px;\n\n  border: none;\n  border-radius: 14px;\n\n  background: linear-gradient(135deg, #7c3aed, #8b5cf6, #6366f1);\n  color: #fff;\n\n  font-size: 17px;\n  font-weight: 800;\n\n  cursor: pointer;\n  transition: 0.25s ease;\n}\n\n.submit:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 16px 28px rgba(124, 58, 237, 0.32);\n}\n\n.submit:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.foot {\n  text-align: center;\n  margin-top: 24px;\n  color: #555;\n}\n\n.foot a {\n  color: #5b21b6;\n  text-decoration: none;\n  font-weight: 700;\n}\n\n.error-msg {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.08);\n  border: 1px solid rgba(239, 68, 68, 0.18);\n  padding: 10px 12px;\n  border-radius: 12px;\n  margin-bottom: 14px;\n  font-size: 14px;\n}\n\n.speech-bubble {\n  position: absolute;\n  top: 14%;\n  left: 15%;\n  z-index: 10;\n\n  width: fit-content;\n  max-width: 340px;\n\n  padding: 14px 20px;\n  border-radius: 18px;\n\n  background: rgba(255, 255, 255, 0.9);\n  color: #1f2937;\n\n  font-size: 15px;\n  font-weight: 600;\n\n  box-shadow: 0 14px 35px rgba(0, 0, 0, 0.1);\n  pointer-events: none;\n}\n\n.auth-bg-orb {\n  position: absolute;\n  border-radius: 999px;\n  filter: blur(55px);\n  opacity: 0.55;\n  animation: floatOrb 7s ease-in-out infinite;\n}\n\n.orb-1 {\n  width: 320px;\n  height: 320px;\n  left: -70px;\n  top: -70px;\n  background: #c4b5fd;\n}\n\n.orb-2 {\n  width: 260px;\n  height: 260px;\n  right: 10%;\n  bottom: 4%;\n  background: #bfdbfe;\n  animation-delay: 1.4s;\n}\n\n.orb-3 {\n  width: 220px;\n  height: 220px;\n  left: 45%;\n  top: 15%;\n  background: #ddd6fe;\n  animation-delay: 2s;\n}\n\n@keyframes floatOrb {\n  0%, 100% {\n    transform: translateY(0) translateX(0);\n  }\n  50% {\n    transform: translateY(-28px) translateX(18px);\n  }\n}\n\n@media (max-width: 992px) {\n  .auth-shell {\n    grid-template-columns: 1fr;\n    gap: 20px;\n    min-height: auto;\n    padding: 30px 0;\n  }\n\n  .canvas-wrap {\n    height: 360px;\n  }\n\n  .signin-card {\n    width: min(430px, 92vw);\n    margin: 0 auto;\n  }\n}\n\n/* Make sure the 3D canvas fits */\n.canvas-wrap canvas {\n    width: 100% !important;\n    height: 100% !important;\n}\n/* Robot Glow */\n.robot-glow {\n  position: absolute;\n  width: 420px;\n  height: 420px;\n\n  left: 12%;\n  top: 50%;\n\n  transform: translateY(-50%);\n\n  background: radial-gradient(\n    circle,\n    rgba(124, 58, 237, 0.28),\n    rgba(59, 130, 246, 0.18),\n    transparent 70%\n  );\n\n  filter: blur(60px);\n  border-radius: 50%;\n  z-index: 0;\n\n  animation: pulseGlow 5s ease-in-out infinite;\n}\n\n@keyframes pulseGlow {\n  0% {\n    transform: translateY(-50%) scale(1);\n  }\n  50% {\n    transform: translateY(-50%) scale(1.08);\n  }\n  100% {\n    transform: translateY(-50%) scale(1);\n  }\n}\n/* === Chat bubble above robot === */\n.speech-bubble {\n  position: absolute;\n  top: 20%;\n  left: 18%;\n  z-index: 10;\n\n  width: fit-content;\n  max-width: 360px;\n  min-width: 0;\n\n  padding: 14px 22px;\n  border-radius: 18px;\n  background: #fff;\n  color: #222;\n\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.4;\n\n  white-space: normal;\n  overflow-wrap: break-word;\n  word-break: normal;\n\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.12);\n  pointer-events: none;\n}\n\n.typing-text {\n  display: inline;\n}\n.speech-bubble::after {\n    content: '';\n    position: absolute;\n    bottom: -8px;\n    left: 40%;\n    border-width: 8px;\n    border-style: solid;\n    border-color: white transparent transparent transparent;\n}\n\n/* === Login Card === */\n.signin-card {\n    background: #fff;\n    border-radius: 20px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n    padding: 40px;\n    width: 380px;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    z-index: 5;\n}\n\n.title {\n    font-size: 1.8rem;\n    font-weight: 700;\n    color: #111;\n    text-align: center;\n}\n\n.subtitle {\n    text-align: center;\n    color: #666;\n    margin-top: -10px;\n    margin-bottom: 10px;\n}\n\n.google-cta {\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    cursor: pointer;\n    font-weight: 500;\n    transition: all 0.2s;\n}\n\n.google-cta:hover {\n    background: #f9f9f9;\n}\n\n.google-icon {\n    width: 20px;\n    height: 20px;\n}\n\n.sep {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #999;\n    font-size: 0.85rem;\n}\n\n.sep span::before,\n.sep span::after {\n    content: '';\n    display: inline-block;\n    width: 35px;\n    height: 1px;\n    background: #ddd;\n    vertical-align: middle;\n    margin: 0 10px;\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.form label {\n    font-weight: 600;\n    color: #333;\n}\n\n.req {\n    color: #e63946;\n}\n\n.form input {\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    padding: 10px;\n    font-size: 0.95rem;\n    transition: 0.2s border-color;\n}\n\n.form input:focus {\n    outline: none;\n    border-color: #7c5dfa;\n    box-shadow: 0 0 0 2px rgba(124, 93, 250, 0.15);\n}\n\n.password-wrap {\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n\n.password-wrap .eye {\n    position: absolute;\n    right: 10px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 1.2rem;\n}\n\n.row-between {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 0.85rem;\n}\n\n.cb input {\n    margin-right: 6px;\n}\n\n.forgot {\n    text-decoration: none;\n    color: #7c5dfa;\n}\n\n.submit {\n    background: #7c5dfa;\n    color: #fff;\n    border: none;\n    border-radius: 10px;\n    padding: 12px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: 0.25s all;\n}\n\n.submit:hover {\n    background: #6a48f7;\n}\n\n.foot {\n    text-align: center;\n    font-size: 0.85rem;\n    color: #555;\n}\n\n/* === RESPONSIVE BREAKPOINTS === */\n\n/* Tablet (<= 1024px) */\n@media (max-width: 1024px) {\n    .signin-3d-root {\n        flex-direction: column;\n        gap: 30px;\n    }\n\n    .canvas-wrap {\n        width: 100%;\n        height: 50vh;\n        margin-bottom: -30px;\n    }\n\n    .signin-card {\n        width: 90%;\n        max-width: 400px;\n    }\n\n    .speech-bubble {\n        top: 10%;\n        font-size: 0.85rem;\n    }\n}\n\n/* Mobile (<= 600px) */\n@media (max-width: 600px) {\n    .signin-3d-root {\n        flex-direction: column;\n        justify-content: flex-start;\n        padding-top: 40px;\n        height: auto;\n        min-height: 100vh;\n    }\n\n    .canvas-wrap {\n        width: 100%;\n        height: 280px;\n    }\n\n    .signin-card {\n        width: 95%;\n        padding: 25px;\n        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);\n    }\n\n    .title {\n        font-size: 1.5rem;\n    }\n\n    .subtitle {\n        font-size: 0.9rem;\n    }\n\n    .speech-bubble {\n        font-size: 0.8rem;\n        top: 5%;\n        left: 50%;\n    }\n\n    .submit {\n        padding: 10px;\n        font-size: 0.95rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
